module.exports = __webpack_public_path__ + "static/media/zambia-shipping-map.059a28e1.png";